import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleService } from '../../../../../services/api-appointment/simple/simple.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { SimpleRequestStatus, SimpleAppointmentStatus } from '../../../../../models/api-appointment/simple/simple.request.model';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-appointment-calendar-view',
  templateUrl: './appointment-calendar-view.component.html',
  styleUrls: ['./appointment-calendar-view.component.css']
})
export class AppointmentCalendarViewComponent implements OnInit {
  @Input() public title: any;
  @Input() public id: number;
  @Input() public date: number;
  @Input() public color: number;
  storeCity: string = "";
  storeComsy: string = "";
  storeAddress: string = "";
  topic: string = "";
  clientCode: string = "";
  notes: string = "";
  name: string = "";
  surname: string = "";
  telephone: string = "";
  email: string = "";
  isFastwebCustomer: string = "";
  appointmentCode: string = "";
  appointmentStatus: string = "";;
  request: any = {};
  pendingBtns: boolean = false;
  confirmedBtns: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private simpleService: SimpleService,
    private toastr: ToastrService,
    private spinner: SpinnerService,
  ) { }

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.getBackground();
    if (this.title == null || typeof this.title == typeof undefined) {
      this.title = "";
    }

    if (this.date == null || typeof this.date == typeof undefined) {
      this.date = 0;
    }



    if (this.id != null && typeof this.id != typeof undefined) {
      this.simpleService.getEntity(this.id).subscribe(
        (response) => {
          if (response) {
            this.setFormValue(response);
          }
        },
        (error: HttpErrorResponse) => {
          this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni dell\'immagine', 'Modifica immagine', {
            timeOut: 5000
          });
          this.spinner.hide();
        }
      );
    }
  }

  setFormValue(response) {
    this.appointmentStatus = response.appointmentStatus;
    this.name = response.name;
    this.telephone = response.telephone;
    this.email = response.email;
    if (response.isFastwebCustomer == TRUE) {
      this.isFastwebCustomer = 'Si';
    } else {
      this.isFastwebCustomer = 'No';
    }
    this.appointmentCode = response.appointmentCode;
    this.storeComsy = response.storeComsy;
    this.storeAddress = response.address;
    this.notes = response.notes;
    this.topic = response.topicTitle;
    this.clientCode = response.clientCode;
    this.checkAppointmentStatus(response.appointmentStatus);
    this.spinner.hide();
  }

  getBackground() {
    let back = document.getElementById('modal-back');
    back.style.backgroundColor = this.color['primary'];
  }

  reserveButton(requestAction) {
    this.request = this.getFormValue(requestAction);
    this.simpleService.changeStatus(this.id, this.request).subscribe(
      (response) => {
        if (response) {

          this.toastr.success('Status modificato con successo', 'Modifica Status', {
            timeOut: 5000
          });
          this.activeModal.close(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la modifica dello status', 'Modifica Status', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }



  getFormValue(requestAction) {
    let request = new SimpleRequestStatus();
    request.appointmentStatus = SimpleAppointmentStatus.COMPLETED;
    switch (requestAction) {
      case 'CONFIRMED': request.appointmentStatus = SimpleAppointmentStatus.CONFIRMED; break;
      case 'CANCELLED': request.appointmentStatus = SimpleAppointmentStatus.CANCELLED; break;
      case 'COMPLETED': request.appointmentStatus = SimpleAppointmentStatus.COMPLETED; break;
    }
    return request;
  }


  onClose() {
    this.activeModal.dismiss();
  }

  checkAppointmentStatus(status) {
    if (status == SimpleAppointmentStatus.PENDING) {
      this.pendingBtns = true;

    } else if (status == SimpleAppointmentStatus.CONFIRMED) {
      this.confirmedBtns = true;
    }
  }
}
